import { createApi } from '@reduxjs/toolkit/query/react';

import { axiosBaseQuery } from '@/api/api';
import { ENDPOINT } from '@/constants/endpoints';
import { Scope, UUID } from '@/types/common';
import {
  EnpsQuestionDetailsData,
  GetAllOverviewResponse,
  QuestionDetailsData,
} from '@/types/questions';

type QuestionsPayload = {
  scope: Scope;
  leaderId?: UUID;
  categories?: string[];
  offset?: number;
  limit?: number;
};

type QuestionPayload = {
  id: UUID;
  scope: Scope;
  leaderId?: UUID;
};

export const questionsApi = createApi({
  reducerPath: 'questionsApi',
  baseQuery: axiosBaseQuery,
  endpoints: builder => ({
    getQuestions: builder.query<GetAllOverviewResponse, QuestionsPayload>({
      query: ({ categories, ...params }) => ({
        url: ENDPOINT.QUESTIONS.GET_ALL(),
        method: 'GET',
        params: {
          ...params,
          categories: categories?.length ? categories.join(',') : undefined,
        },
      }),
    }),
    getQuestion: builder.query<QuestionDetailsData, QuestionPayload>({
      query: ({ id, scope, leaderId }) => ({
        url: ENDPOINT.QUESTIONS.GET(id),
        method: 'GET',
        params: { scope, leaderId },
      }),
    }),
    getEnpsQuestion: builder.query<EnpsQuestionDetailsData, QuestionPayload>({
      query: ({ id, scope, leaderId }) => ({
        url: ENDPOINT.QUESTIONS.GET(id),
        method: 'GET',
        params: { scope, leaderId },
      }),
    }),
  }),
});

export const { useGetQuestionsQuery, useGetQuestionQuery, useGetEnpsQuestionQuery } = questionsApi;
